const getPlayerSetting = (key) => localStorage.getItem(`player-${key}`)
const setPlayerSetting = (key, val) => localStorage.setItem(`player-${key}`, JSON.stringify(val))

export { setPlayerSetting, getPlayerSetting }
